import React from 'react';
import { Button } from './ui/Button';
import { ChevronRight, ShieldCheck } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-[85vh] flex items-center justify-center overflow-hidden" data-id="element-117">
      {/* Background Image & Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-118">
        <img src="https://cdn.magicpatterns.com/uploads/dXp8Bprh2hWsHC1CTJFB6a/619829210_122120024037009454_65520515804250095_n.jpg" alt="Drop Zone Cleanup Co. camo truck and dumpster trailer on-site in a Georgia neighborhood" className="w-full h-full object-cover opacity-40 mix-blend-luminosity" data-id="element-119" />
        <div className="absolute inset-0 bg-gradient-to-t from-background via-background/80 to-background/40" data-id="element-120" />
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10" data-id="element-121" />
      </div>

      <div className="container relative z-10 mx-auto px-4 py-20 flex flex-col items-center text-center" data-id="element-122">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary/80 border border-border text-xs font-bold uppercase tracking-widest text-primary mb-8" data-id="element-123">
          <ShieldCheck className="h-4 w-4" data-id="element-124" />
          Veteran-Owned & Operated
        </div>

        <h1 className="font-heading font-black text-5xl md:text-7xl lg:text-8xl tracking-tighter uppercase mb-6 max-w-5xl leading-[0.9]" data-id="element-125">
          Your Site. <br data-id="element-126" />
          <span className="text-primary" data-id="element-127">Our Mission.</span>
        </h1>

        <p className="text-lg md:text-xl text-foreground/90 max-w-2xl mb-10 font-medium [text-shadow:0_1px_8px_rgba(0,0,0,0.6)]" data-id="element-128">
          Professional junk removal and construction cleanup in Winder, GA. We
          bring military precision, discipline, and reliability to every job.
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-4 w-full sm:w-auto" data-id="element-129">
          <Button size="lg" className="w-full sm:w-auto h-auto min-h-14 py-3 px-6 sm:px-8 text-base sm:text-lg uppercase font-bold tracking-wider group whitespace-normal text-center" data-id="element-130">
            Get a Straightforward Quote
            <ChevronRight className="ml-2 h-5 w-5 shrink-0 group-hover:translate-x-1 transition-transform" data-id="element-131" />
          </Button>
          <Button size="lg" variant="outline" className="w-full sm:w-auto h-auto min-h-14 py-3 px-6 sm:px-8 text-base sm:text-lg uppercase font-bold tracking-wider bg-background/50 backdrop-blur whitespace-normal text-center" data-id="element-132">
            Call 706-714-0156
          </Button>
        </div>

        {/* Stats / Trust Strip */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-20 pt-10 border-t border-border/50 w-full max-w-4xl" data-id="element-133">
          <div className="flex flex-col items-center gap-1" data-id="element-134">
            <span className="text-3xl font-black text-foreground" data-id="element-135">100%</span>
            <span className="text-xs text-muted-foreground uppercase tracking-widest font-bold" data-id="element-136">
              Mission Success
            </span>
          </div>
          <div className="flex flex-col items-center gap-1" data-id="element-137">
            <span className="text-3xl font-black text-foreground" data-id="element-138">5★</span>
            <span className="text-xs text-muted-foreground uppercase tracking-widest font-bold" data-id="element-139">
              Top Rated
            </span>
          </div>
          <div className="flex flex-col items-center gap-1" data-id="element-140">
            <span className="text-3xl font-black text-foreground" data-id="element-141">Fully</span>
            <span className="text-xs text-muted-foreground uppercase tracking-widest font-bold" data-id="element-142">
              Licensed & Insured
            </span>
          </div>
          <div className="flex flex-col items-center gap-1" data-id="element-143">
            <span className="text-3xl font-black text-foreground" data-id="element-144">Fast</span>
            <span className="text-xs text-muted-foreground uppercase tracking-widest font-bold" data-id="element-145">
              Deployment
            </span>
          </div>
        </div>
      </div>
    </section>;
}